(function () {
  'use strict';
  const db = () => window.SM.DB;
  const ui = () => window.SM.UI;
  const util = () => window.SM.UTIL;

  async function load() {
    const tbody = document.getElementById('ims-cust-tbody');
    if (!tbody) return;
    tbody.innerHTML = `<tr><td colspan="8" class="ims__table-empty"><i class="ti ti-loader-2 ims__spin"></i></td></tr>`;

    const search = document.getElementById('ims-cust-search')?.value?.trim() || '';
    const { data: customers, error } = await db().select('customers', { order: { col: 'business_name' } });
    if (error) { ui().toast('Failed to load customers', 'error'); return; }
    let items = customers || [];

    if (search) { 
      const s = search.toLowerCase();
      items = items.filter(c =>
        c.business_name?.toLowerCase().includes(s) ||
        c.contact_name?.toLowerCase().includes(s) ||
        c.postcode?.toLowerCase().includes(s) ||
        c.email?.toLowerCase().includes(s)
      );
    }

    if (!items.length) {
      tbody.innerHTML = '<tr><td colspan="8" class="ims__table-empty">No customers found</td></tr>';
      return;
    }

    // Get order counts and balances
    const { data: orderCounts } = await db().select('orders', {
      select: 'customer_id',
      in: { customer_id: items.map(c => c.id) }
    });
    const countMap = {};
    (orderCounts||[]).forEach(o => { if (o.customer_id) countMap[o.customer_id] = (countMap[o.customer_id]||0)+1; });

    const { data: receivables } = await db().select('accounts_receivable', {
      select: 'customer_id,amount,paid_amount',
      in: { customer_id: items.map(c => c.id) },
      neq: { status: 'paid' }
    });
    const balanceMap = {};
    (receivables||[]).forEach(r => {
      if (r.customer_id) balanceMap[r.customer_id] = (balanceMap[r.customer_id]||0) + ((r.amount||0)-(r.paid_amount||0));
    });

    tbody.innerHTML = items.map(c => `
      <tr>
        <td><span class="ims__link" onclick="window.IMS_CUSTOMERS.openCustomer('${c.id}')">${util().sanitize(c.business_name||'—')}</span></td>
        <td>${util().sanitize(c.contact_name||'—')}</td>
        <td>${util().sanitize(c.postcode||'—')}</td>
        <td>${util().sanitize(c.phone||'—')}</td>
        <td>${c.credit_limit ? util().formatCurrency(c.credit_limit) : '—'}</td>
        <td style="font-weight:600;color:${(balanceMap[c.id]||0)>0?'var(--ims-warning)':''}">${balanceMap[c.id] ? util().formatCurrency(balanceMap[c.id]) : '£0.00'}</td>
        <td>${countMap[c.id]||0}</td>
        <td>
          <div class="ims__btn-group">
            <button class="ims__btn ims__btn--secondary ims__btn--sm ims__btn--icon" onclick="window.IMS_CUSTOMERS.openCustomer('${c.id}')" title="View"><i class="ti ti-eye"></i></button>
            <button class="ims__btn ims__btn--secondary ims__btn--sm ims__btn--icon" onclick="window.IMS_CUSTOMERS.showForm('${c.id}')" title="Edit"><i class="ti ti-edit"></i></button>
          </div>
        </td>
      </tr>`).join('');
  }

  async function openCustomer(id) {
    const { data: c } = await db().select('customers', { eq: { id }, maybeSingle: true, noCompanyFilter: true });
    if (!c) return;

    const { data: orders } = await db().select('orders', {
      select: 'id,order_number,total_value,status,created_at',
      eq: { customer_id: id }, order: { col: 'created_at', asc: false }, limit: 10
    });

    const totalSpend  = (orders||[]).reduce((s, o) => s + (o.total_value||0), 0);
    const lastOrder   = orders?.[0];

    ui().openModal(`Customer: ${c.business_name}`, `
      <div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-bottom:14px">
        <div><span class="ims__label">Business name</span><div style="font-weight:600">${util().sanitize(c.business_name)}</div></div>
        <div><span class="ims__label">Contact person</span><div>${util().sanitize(c.contact_name||'—')}</div></div>
        <div><span class="ims__label">Phone</span><div>${util().sanitize(c.phone||'—')}</div></div>
        <div><span class="ims__label">Email</span><div>${util().sanitize(c.email||'—')}</div></div>
        <div><span class="ims__label">Postcode</span><div>${util().sanitize(c.postcode||'—')}</div></div>
        <div><span class="ims__label">VAT number</span><div>${util().sanitize(c.vat_number||'—')}</div></div>
        <div><span class="ims__label">Credit terms</span><div>${util().sanitize(c.credit_terms||'—')}</div></div>
        <div><span class="ims__label">Credit limit</span><div style="font-weight:600">${c.credit_limit ? util().formatCurrency(c.credit_limit) : 'No limit set'}</div></div>
        <div style="grid-column:1/-1"><span class="ims__label">Address</span><div>${util().sanitize(c.address||'—')}</div></div>
        ${c.notes ? `<div style="grid-column:1/-1"><span class="ims__label">Notes</span><div>${util().sanitize(c.notes)}</div></div>` : ''}
      </div>
      <hr class="ims__divider">
      <div style="display:grid;grid-template-columns:repeat(3,1fr);gap:8px;margin-bottom:14px">
        <div class="ims__stat" style="padding:10px"><div class="ims__stat-label">Total orders</div><div class="ims__stat-value" style="font-size:18px">${(orders||[]).length}</div></div>
        <div class="ims__stat" style="padding:10px"><div class="ims__stat-label">Total spend</div><div class="ims__stat-value" style="font-size:18px">${util().formatCurrency(totalSpend)}</div></div>
        <div class="ims__stat" style="padding:10px"><div class="ims__stat-label">Last order</div><div class="ims__stat-value" style="font-size:14px">${lastOrder ? util().formatDate(lastOrder.created_at) : 'Never'}</div></div>
      </div>
      <strong style="font-size:13px">Recent orders</strong>
      <div class="ims__table-wrap" style="margin-top:8px">
        <table class="ims__table">
          <thead><tr><th>Order #</th><th>Value</th><th>Date</th><th>Status</th></tr></thead>
          <tbody>${(orders||[]).map(o => `
            <tr>
              <td><span class="ims__link" onclick="window.SM.UI.showPanel('orders')">${util().sanitize(o.order_number)}</span></td>
              <td>${util().formatCurrency(o.total_value)}</td>
              <td>${util().formatDate(o.created_at)}</td>
              <td>${util().pill(o.status)}</td>
            </tr>`).join('') || '<tr><td colspan="4" class="ims__table-empty">No orders yet</td></tr>'}
          </tbody>
        </table>
      </div>
    `, `
      <button class="ims__btn ims__btn--ghost" onclick="window.IMS_CUSTOMERS.showForm('${c.id}')"><i class="ti ti-edit"></i> Edit</button>
      <button class="ims__btn ims__btn--primary" onclick="window.SM.UI.closeModal()">Close</button>
    `, 'lg');
  }

  async function showForm(existingId = null) {
    let c = null;
    if (existingId) {
      const { data } = await db().select('customers', { eq: { id: existingId }, maybeSingle: true, noCompanyFilter: true });
      c = data;
    }
    ui().openModal(existingId ? `Edit: ${c?.business_name}` : 'Add wholesale customer', `
      <div class="ims__form-grid">
        <div class="ims__form-group ims__form-group--full"><label class="ims__label ims__label--req">Business name</label><input class="ims__input" type="text" id="ims-nc-bname" value="${util().sanitize(c?.business_name||'')}"></div>
        <div class="ims__form-group"><label class="ims__label">Contact person</label><input class="ims__input" type="text" id="ims-nc-contact" value="${util().sanitize(c?.contact_name||'')}"></div>
        <div class="ims__form-group"><label class="ims__label ims__label--req">Postcode</label><input class="ims__input" type="text" id="ims-nc-postcode" value="${util().sanitize(c?.postcode||'')}"></div>
        <div class="ims__form-group"><label class="ims__label">Phone</label><input class="ims__input" type="tel" id="ims-nc-phone" value="${util().sanitize(c?.phone||'')}"></div>
        <div class="ims__form-group"><label class="ims__label">Email</label><input class="ims__input" type="email" id="ims-nc-email" value="${util().sanitize(c?.email||'')}"></div>
        <div class="ims__form-group"><label class="ims__label">VAT number</label><input class="ims__input" type="text" id="ims-nc-vat" value="${util().sanitize(c?.vat_number||'')}"></div>
        <div class="ims__form-group"><label class="ims__label">Credit terms</label>
          <select class="ims__select" id="ims-nc-terms">
            ${['Advance payment','Cash on delivery','7 days net','14 days net','30 days net','60 days net'].map(t=>`<option ${c?.credit_terms===t?'selected':''}>${t}</option>`).join('')}
          </select></div>
        <div class="ims__form-group"><label class="ims__label">Credit limit (£)</label><input class="ims__input" type="number" step="0.01" id="ims-nc-limit" value="${c?.credit_limit||''}" placeholder="0 = no limit"></div>
        <div class="ims__form-group"><label class="ims__label ims__label--req">Customer type</label>
          <select class="ims__select" id="ims-nc-type">
            <option value="wholesale" ${(c?.customer_type||'wholesale')==='wholesale'?'selected':''}>Wholesale</option>
            <option value="retailer" ${c?.customer_type==='retailer'?'selected':''}>Retailer</option>
            <option value="trade" ${c?.customer_type==='trade'?'selected':''}>Trade</option>
          </select></div>
        <div class="ims__form-group"><label class="ims__label ims__label--req">Delivery arrangement</label>
          <select class="ims__select" id="ims-nc-delivery">
            <option value="mdf_delivers" ${(c?.delivery_arrangement||'mdf_delivers')==='mdf_delivers'?'selected':''}>MDF London delivers to their address</option>
            <option value="customer_collects" ${c?.delivery_arrangement==='customer_collects'?'selected':''}>Customer collects from our warehouse</option>
          </select></div>
        <div class="ims__form-group ims__form-group--full"><label class="ims__label ims__label--req">Delivery address</label><textarea class="ims__textarea" id="ims-nc-address" rows="2">${util().sanitize(c?.address||'')}</textarea></div>
        <div class="ims__form-group ims__form-group--full"><label class="ims__label">Notes</label><textarea class="ims__textarea" id="ims-nc-notes" rows="2">${util().sanitize(c?.notes||'')}</textarea></div>
        <hr class="ims__divider">
        <div style="font-size:13px;font-weight:600;color:var(--ims-text);margin-bottom:10px">Pricing & discount</div>
        <div class="ims__form-group"><label class="ims__label">Pricing basis</label>
          <select class="ims__select" id="ims-nc-pricing-basis">
            <option value="wholesale" ${(c?.pricing_basis||'wholesale')==='wholesale'?'selected':''}>Wholesale price</option>
            <option value="rrp" ${c?.pricing_basis==='rrp'?'selected':''}>RRP</option>
            <option value="custom" ${c?.pricing_basis==='custom'?'selected':''}>Custom per product</option>
          </select>
          <span class="ims__input-hint">Which base price to use for this customer's orders</span>
        </div>
        <div class="ims__form-group"><label class="ims__label">Standing discount type</label>
          <select class="ims__select" id="ims-nc-discount-type" onchange="window.IMS_CUSTOMERS.onDiscountTypeChange()">
            <option value="" ${!c?.discount_type?'selected':''}>No standing discount</option>
            <option value="percentage" ${c?.discount_type==='percentage'?'selected':''}>Percentage off (%)</option>
            <option value="fixed_amount" ${c?.discount_type==='fixed_amount'?'selected':''}>Fixed amount off (£)</option>
          </select>
        </div>
        <div class="ims__form-group" id="ims-nc-discount-value-group" style="${c?.discount_type?'':'display:none'}">
          <label class="ims__label">Discount value</label>
          <input class="ims__input" type="number" step="0.01" min="0" id="ims-nc-discount-value"
            value="${c?.discount_value||''}"
            placeholder="${c?.discount_type==='percentage'?'e.g. 20 for 20% off':'e.g. 50 for £50 off'}">
          <span class="ims__input-hint">Applied automatically on every order for this customer</span>
        </div>
      </div>
    `, `
      <button class="ims__btn ims__btn--ghost" onclick="window.SM.UI.closeModal()">Cancel</button>
      <button class="ims__btn ims__btn--primary" onclick="window.IMS_CUSTOMERS.save('${existingId||''}')"><i class="ti ti-check"></i> ${existingId?'Save changes':'Add customer'}</button>
    `, 'lg');
  }

  function onDiscountTypeChange(){
    const type=document.getElementById('ims-nc-discount-type')?.value;
    const group=document.getElementById('ims-nc-discount-value-group');
    const input=document.getElementById('ims-nc-discount-value');
    if(group) group.style.display=type?'':'none';
    if(input) input.placeholder=type==='percentage'?'e.g. 20 for 20% off':'e.g. 50 for £50 off';
  }

  async function save(existingId) {
    const g = id => document.getElementById(id)?.value?.trim() || '';
    const bname = g('ims-nc-bname'), postcode = g('ims-nc-postcode').toUpperCase(), address = g('ims-nc-address');
    if (!bname)    { ui().toast('Business name is required', 'error'); return; }
    if (!postcode) { ui().toast('Postcode is required', 'error'); return; }
    if (!address)  { ui().toast('Address is required', 'error'); return; }

    const discountType = g('ims-nc-discount-type') || null;
    const data = {
      business_name: bname, contact_name: g('ims-nc-contact'),
      postcode, address, phone: g('ims-nc-phone'), email: g('ims-nc-email'),
      vat_number: g('ims-nc-vat'), credit_terms: g('ims-nc-terms'),
      credit_limit: parseFloat(g('ims-nc-limit')) || 0,
      customer_type: g('ims-nc-type') || 'wholesale',
      delivery_arrangement: g('ims-nc-delivery') || 'mdf_delivers',
      pricing_basis: g('ims-nc-pricing-basis') || 'wholesale',
      discount_type: discountType,
      discount_value: discountType ? (parseFloat(g('ims-nc-discount-value')) || 0) : null,
      notes: g('ims-nc-notes') || null
    };

    const { error } = existingId
      ? await db().update('customers', existingId, data)
      : await db().insert('customers', data);

    if (error) { ui().toast('Failed: ' + error.message, 'error'); return; }
    ui().closeModal();
    ui().toast(`Customer ${existingId?'updated':'added'}`, 'success');
    load();
  }

  // ─── IMPORT ──────────────────────────────────────────────────────
  function showImport() {
    ui().openModal('Import customers', `
      <div class="ims__alert ims__alert--info"><i class="ti ti-info-circle"></i>
        <span>Download the template, fill it in and upload to bulk import customers.</span>
      </div>
      <div class="ims__btn-group" style="margin-bottom:16px">
        <button class="ims__btn ims__btn--secondary" onclick="window.IMS_CUSTOMERS.downloadTemplate()"><i class="ti ti-download"></i> Download template</button>
      </div>
      <div class="ims__form-group">
        <label class="ims__label">Select CSV file</label>
        <input type="file" accept=".csv" id="ims-cust-import-file" class="ims__input" onchange="window.IMS_CUSTOMERS.previewImport(this)">
      </div>
      <div id="ims-cust-import-preview"></div>
    `, `
      <button class="ims__btn ims__btn--ghost" onclick="window.SM.UI.closeModal()">Cancel</button>
      <button class="ims__btn ims__btn--primary" id="ims-cust-commit-btn" style="display:none" onclick="window.IMS_CUSTOMERS.commitImport()"><i class="ti ti-check"></i> Import customers</button>
    `, 'lg');
  }

  function downloadTemplate() {
    util().exportCSV(
      ['Business Name','Contact Name','Email','Phone','Postcode','Address','VAT Number','Credit Terms','Credit Limit','Customer Type (Wholesale/Retailer/Trade/Dropship)','Delivery Arrangement (MDF Delivers/Customer Collects)','Notes'],
      [['Acme Furniture Ltd','John Smith','john@acme.com','07700900000','SW1A 1AA','1 Example St London','GB123456789','30 days net','5000','Wholesale','MDF Delivers','']],
      'customers_template'
    );
  }

  let _custImportRows = [];

  // Normalizes free-text CSV values into the exact customer_type /
  // delivery_arrangement values the manual Add/Edit Customer form uses
  // (id="ims-nc-type" / id="ims-nc-delivery", confirmed at lines 138-149
  // of this file), defaulting to the same values that form itself
  // defaults to when left untouched ('wholesale' / 'mdf_delivers').
  function _custTypeFromCsv(raw){
    const map = { wholesale:'wholesale', retailer:'retailer', retail:'retailer', trade:'trade', dropship:'dropship' };
    return map[(raw||'').trim().toLowerCase()] || 'wholesale';
  }
  function _deliveryArrangementFromCsv(raw){
    const map = {
      'mdf delivers':'mdf_delivers', mdf:'mdf_delivers', 'we deliver':'mdf_delivers',
      'customer collects':'customer_collects', collects:'customer_collects', 'self collect':'customer_collects'
    };
    return map[(raw||'').trim().toLowerCase()] || 'mdf_delivers';
  }

  async function previewImport(input) {
    const file = input.files?.[0];
    if (!file) return;
    const text = await file.text();
    const { headers, rows } = util().parseCSV(text);
    const preview  = document.getElementById('ims-cust-import-preview');
    const commitBtn= document.getElementById('ims-cust-commit-btn');

    _custImportRows = rows.map(row => {
      const get = col => { const i = headers.indexOf(col); return i>=0 ? row[i]||'' : ''; };
      return {
        business_name: get('Business Name'),
        contact_name:  get('Contact Name'),
        email:         get('Email'),
        phone:         get('Phone'),
        postcode:      get('Postcode').toUpperCase(),
        address:       get('Address'),
        vat_number:    get('VAT Number'),
        credit_terms:  get('Credit Terms') || 'Advance payment',
        credit_limit:  parseFloat(get('Credit Limit')) || 0,
        customer_type: _custTypeFromCsv(get('Customer Type (Wholesale/Retailer/Trade/Dropship)') || get('Customer Type')),
        delivery_arrangement: _deliveryArrangementFromCsv(get('Delivery Arrangement (MDF Delivers/Customer Collects)') || get('Delivery Arrangement')),
        notes:         get('Notes'),
        valid:         !!(get('Business Name') && get('Postcode'))
      };
    });

    const valid = _custImportRows.filter(r => r.valid).length;
    const typeLabel = t => ({wholesale:'Wholesale',retailer:'Retailer',trade:'Trade',dropship:'Dropship'}[t]||t);
    const deliveryLabel = d => d==='customer_collects' ? 'Customer collects' : 'MDF delivers';
    if (preview) preview.innerHTML = `
      <div class="ims__alert ims__alert--success" style="margin-top:12px"><i class="ti ti-check"></i>
        <span>Found <strong>${_custImportRows.length} rows</strong> — ${valid} valid</span>
      </div>
      <div class="ims__table-wrap" style="max-height:200px;overflow-y:auto;margin-top:8px">
        <table class="ims__table">
          <thead><tr><th>Business name</th><th>Postcode</th><th>Phone</th><th>Type</th><th>Delivery</th><th>Valid</th></tr></thead>
          <tbody>${_custImportRows.slice(0,10).map(r=>`
            <tr>
              <td>${util().sanitize(r.business_name)}</td><td>${util().sanitize(r.postcode)}</td>
              <td>${util().sanitize(r.phone)}</td>
              <td style="font-size:11px">${typeLabel(r.customer_type)}</td>
              <td style="font-size:11px">${deliveryLabel(r.delivery_arrangement)}</td>
              <td>${r.valid?'<span class="ims__pill ims__pill--success">✓</span>':'<span class="ims__pill ims__pill--danger">✗</span>'}</td>
            </tr>`).join('')}
          </tbody>
        </table>
      </div>`;
    if (commitBtn) commitBtn.style.display = valid>0 ? 'inline-flex' : 'none';
  }

  async function commitImport() {
    const valid = _custImportRows.filter(r => r.valid);
    let created = 0;
    for (const row of valid) {
      // Built explicitly rather than spreading `row` directly — the
      // parsed row also carries a `valid` boolean used only for the
      // preview table above, which is not a real column on `customers`.
      const payload = {
        business_name: row.business_name,
        contact_name:  row.contact_name || null,
        email:         row.email || null,
        phone:         row.phone || null,
        postcode:      row.postcode,
        address:       row.address || null,
        vat_number:    row.vat_number || null,
        credit_terms:  row.credit_terms,
        credit_limit:  row.credit_limit,
        customer_type: row.customer_type,
        delivery_arrangement: row.delivery_arrangement,
        notes:         row.notes || null
      };
      const { error } = await db().insert('customers', payload);
      if (!error) created++;
    }
    ui().closeModal();
    ui().toast(`${created} customers imported`, 'success');
    _custImportRows = [];
    load();
  }

  window.addEventListener('ims:panel', e => { if (e.detail.panel === 'customers') load(); });
  window.addEventListener('ims:ready', () => {
    const newBtn = document.getElementById('ims-cust-new-btn');
    if (newBtn) {
      if (window.SM.AUTH.isAdmin()) {
        newBtn.addEventListener('click', () => showForm());
      } else {
        newBtn.style.display = 'none';
      }
    }
    document.getElementById('ims-cust-import-btn')?.addEventListener('click', showImport);
    const s = document.getElementById('ims-cust-search');
    if (s) s.addEventListener('input', util().debounce(load, 350));
  });

  window.IMS_CUSTOMERS = { load, openCustomer, showForm, save, onDiscountTypeChange, showImport, downloadTemplate, previewImport, commitImport };
})();
